import { useAppDispatch, useAppSelector } from '../../../redux/hooks/StoreHook';
import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { VARIANTS_TOAST_ALERT } from '../../../dashboard/components/left-menu/Variants';
import { toggleToast } from '../../../redux/features/Toast/ToastSlice';
import { ToastStatus } from './ToastStatus';
import { useTranslation } from 'react-i18next';

export const ToastWrapper: React.FunctionComponent<any> = () => {
	const toastStorage = useAppSelector(state => state.toast);
	const dispatch = useAppDispatch();
	const { t } = useTranslation();

	let iconClass = 'pi-check';
	if (toastStorage.status === ToastStatus.ERROR) {
		iconClass = 'pi-times';
	} else if (toastStorage.status === ToastStatus.WARNING) {
		iconClass = 'pi-info-circle';
	}

	const close = (): void => {
		dispatch(
			toggleToast({
				open: false,
				text: '',
				status: ToastStatus.WARNING,
				autoClose: false,
			})
		);
	};

	useEffect(() => {
		if (toastStorage.autoClose && toastStorage.open) {
			setTimeout(() => {
				close();
			}, toastStorage.closeTimeout);
		}
	}, [toastStorage.open]);

	return (
		<div>
			<AnimatePresence>
				{toastStorage.open && (
					<motion.div
						variants={VARIANTS_TOAST_ALERT}
						initial={'open'}
						animate={'open'}
						exit={'closed'}
						className={`toast-block color-${toastStorage.status.toLowerCase()}`}
					>
						<div className={'icon-box'}>
							<i className={`pi ${iconClass}`}></i>
						</div>
						<p>{toastStorage.text}</p>
						{toastStorage.callBackInfo && (
							<a onClick={toastStorage.callBackInfo.fxAction}>
								{t(toastStorage.callBackInfo.key)}
							</a>
						)}
						<div onClick={close} className={'close-box'}>
							<i className={'pi pi-times'}></i>
						</div>
					</motion.div>
				)}
			</AnimatePresence>
		</div>
	);
};
